module.exports = __webpack_public_path__ + "img/vu.5c33b1e.svg";